import React, {useState} from 'react';
import ImagePreview from '../../../ImagePreview';
import {InteractionsPreviewItem} from '../../InteractionsMenuItems';
import edit from '../../../../assets/edit.svg';

const EditImage = ({
                     fileID,
                     content,
                     updateFile,
                     updateFileMetadata,
                     getFileList,
                     editFormValues,
                     setClickOutsideAllowed,
                     closeDropdown,
                     itemProps,
                     shumaId,
                   }) => {
  const [loading, setLoading] = useState(false);
  const handleOpen = async () => {
    closeDropdown();
    if (!Boolean(content)) {
      setLoading(true);
      await updateFile();
    }
    setClickOutsideAllowed(false);
    setLoading(false);
  };
  const handleVisitDateApprove = (image, payload) => {
    const {freeText, freeID} = payload;
    updateFileMetadata({
      shumaId,
      fileID,
      freeText,
      freeID,
    })
      .then(() => getFileList({shumaId}))
      .then(() => setClickOutsideAllowed(true))
      .finally(closeDropdown);
  };
  const handleReject = () => setClickOutsideAllowed(true);

  return (
    <ImagePreview
      Button={InteractionsPreviewItem({
        label: 'עריכת פרטי קובץ',
        icon: edit,
        onClick: handleOpen,
        ...itemProps[1]
      })}
      image={content}
      formInitialValues={editFormValues}
      onConfirm={handleVisitDateApprove}
      onReject={handleReject}
      loading={loading}
      formFields={'freeTextAndFloors'}
    />
  );
};

export default EditImage;